import { computed, defineComponent } from 'vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { MyCustomUploadAdapterPlugin } from '@/core/plugins/uploadAdapter';
export default defineComponent({
    props: {
        modelValue: String,
        disabled: Boolean,
        preview: Boolean
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const value = computed({
            get() {
                return props.modelValue;
            },
            set(value) {
                emit('update:modelValue', value);
            }
        });
        const editorConfig = computed(() => {
            return {
                extraPlugins: [MyCustomUploadAdapterPlugin],
                toolbar: [
                    'heading',
                    '|',
                    'bold',
                    'italic',
                    '|',
                    'numberedList',
                    'bulletedList',
                    '|',
                    'uploadImage',
                    '|',
                    'undo',
                    'redo'
                ]
            };
        });
        return {
            value,
            editor: ClassicEditor,
            editorConfig
        };
    }
});
